import { render, staticRenderFns } from "./DownLoadList.vue?vue&type=template&id=d27a2bc6&scoped=true&"
import script from "./DownLoadList.vue?vue&type=script&lang=js&"
export * from "./DownLoadList.vue?vue&type=script&lang=js&"
import style0 from "./DownLoadList.vue?vue&type=style&index=0&id=d27a2bc6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27a2bc6",
  null
  
)

export default component.exports